import React, { createContext, useContext } from 'react'
import { useCampaignCreateCopperOpportunity } from './useCampaignCreateCopperOpportunity'

type CampaignCreateCopperContextValue = ReturnType<typeof useCampaignCreateCopperOpportunity>

const CampaignCreateCopperContext = createContext<CampaignCreateCopperContextValue | null>(null)
CampaignCreateCopperContext.displayName = 'CampaignCreateCopperContext'

export const CampaignCreateCopperProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const value = useCampaignCreateCopperOpportunity()
  return <CampaignCreateCopperContext.Provider value={value}>{children}</CampaignCreateCopperContext.Provider>
}

export const useCampaignCreateCopperContext = (): CampaignCreateCopperContextValue => {
  const value = useContext(CampaignCreateCopperContext)
  if (!value) throw new Error('CampaignCreateCopperProvider is required')
  return value
}
